import React, { FC, Suspense } from "react";
import { useSelector } from "react-redux";

import { Card } from "../../components/common";
import {
  InvoiceForm,
  WalletListForm,
  FormHeader,
} from "../../components/forms/invoice";
import { InvoiceSidebarDefault } from "../../components/sidebar/invoice";
import { UIActionProvider } from "../../contexts/UIActionContext";
import { useDisplayInvoiceWalletSection } from "../../hooks/useDisplayInvoiceWalletSection";
import InvoiceLayout from "../../layouts/Invoice.layout";
import { selectInvoice } from "../../store/reducers/invoice";

export const Invoice: FC = () => {
  const invoice = useSelector(selectInvoice);
  const showWalletForm = useDisplayInvoiceWalletSection(invoice);

  if (!invoice) {
    return <></>;
  }

  return (
    <Suspense fallback={Loader}>
      {invoice && (
        <UIActionProvider>
          <InvoiceLayout
            contentClassName="flex flex-col gap-12"
            sidebar={<InvoiceSidebarDefault data={invoice} />}
          >
            <FormHeader data={invoice} />

            <Card>
              <InvoiceForm data={invoice} />
            </Card>

            {showWalletForm && (
              <Card>
                <WalletListForm />
              </Card>
            )}
          </InvoiceLayout>
        </UIActionProvider>
      )}
    </Suspense>
  );
};

const Loader = <>Loading...</>;
